Wee.fn.make('thanks', {
	init: function() {
		var cookie = this.$private.getResourceCookie();

		if (cookie) {
			// Get the file link
			$.fetch.request({
				url: '/ajax/file/' + cookie,
				success: function(response) {
					var $downloadAnchor = $('ref:fileDownload');

					$('ref:regularButton').hide();

					$downloadAnchor.attr('href', response);

					$downloadAnchor.show();
				}
			});
		}
	}
}, {
	/**
	 * Gets a cookie.
	 *
	 * @private
	 * @return cookie
	 */
	getResourceCookie: function() {
		var cookie = document.cookie.replace(/(?:(?:^|.*;\s*)resource\s*\=\s*([^;]*).*$)|^.*$/, '$1');

		return cookie || false;
	}
});